interface TradeRow {
  direction: string;
  quantity?: number;
  mid?: number;
  close: number;
  tradeDate: string;
  trade_start: string;
  trade_end?: string;
  cost_to_trade: number;
  [key: string]: any;
}

interface LegData {
  [legId: string]: TradeRow[];
}

interface BacktestSeriesPayload {
  dates?: string[];
  raw_data: LegData;
  pnl: number[];
  returns: number[];
  net_capital_gain: number;
  total_trades: number;
  average_cost_per_trade: number;
  average_pnl_per_trade: number;
  max_loss: number;
  max_gain: number;
  max_cost: number;
  hit_ratio: number;
  max_drawdown: number;
  average_profit_percent: number;
  max_profit_percent: number;
  max_loss_percent: number;
}

function isBacktestSeriesPayload(value: unknown): value is BacktestSeriesPayload {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const payload = value as Partial<BacktestSeriesPayload>;
    return (
        !!payload.raw_data
        && Array.isArray(payload.pnl)
        && Array.isArray(payload.returns)
    );
}

function hasChartableBacktestResults(
    value: LegData | BacktestSeriesPayload | null | undefined
): value is LegData | BacktestSeriesPayload {
    if (!value || typeof value !== 'object') {
        return false;
    }
    if (isBacktestSeriesPayload(value)) {
        return (
            Object.keys(value.raw_data || {}).length > 0
            || (value.pnl?.length ?? 0) > 0
        );
    }
    return Object.keys(value).length > 0;
}

export {
    isBacktestSeriesPayload,
    hasChartableBacktestResults
};

export type {
    TradeRow,
    LegData,
    BacktestSeriesPayload
};
